import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c4efc48"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("附件列表")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出pdf")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 下 载 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 删 除 ")
const _hoisted_8 = { id: "padPreview" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pdfCode" }, [
  /*#__PURE__*/_createElementVNode("canvas", {
    src: "",
    alt: "",
    class: "",
    id: "barcode"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-90" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"textAlign":"center"} }, "房租物管水电账单", -1))
const _hoisted_12 = { class: "d-flex justify-content--around" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content--between" }, [
  /*#__PURE__*/_createElementVNode("span", null, "费用类型"),
  /*#__PURE__*/_createElementVNode("span", { style: {"position":"relative","right":"15px"} }, "币种"),
  /*#__PURE__*/_createElementVNode("span", { style: {"position":"relative","right":"52px"} }, "金额")
], -1))
const _hoisted_14 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "feeType" }, "房租", -1))
const _hoisted_16 = { class: "feeNumber" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "feeType" }, "月物管费", -1))
const _hoisted_19 = { class: "feeNumber" }
const _hoisted_20 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "feeType" }, "水电费", -1))
const _hoisted_22 = { class: "feeNumber" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "feeType" }, "押金", -1))
const _hoisted_25 = { class: "feeNumber" }
const _hoisted_26 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "feeType" }, "其他费用", -1))
const _hoisted_28 = { class: "feeNumber" }
const _hoisted_29 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "feeType" }, "合计", -1))
const _hoisted_31 = { class: "feeNumber" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content--between" }, [
  /*#__PURE__*/_createElementVNode("span", null, "收款人信息")
], -1))
const _hoisted_33 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收款人名称", -1))
const _hoisted_35 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "银行名称", -1))
const _hoisted_37 = { class: "d-flex align-items-center justify-content--between item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收款账号", -1))
const _hoisted_39 = { class: "billLeader" }
const _hoisted_40 = { class: "dialog-footer" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("导出pdf")

  
const __default__ = {
  name: 'leaseBill'
}
import { computed, ref, Ref, onActivated, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { getNumber, formatNumber } from '@/utils/index'
import html2pdf from 'html2pdf.js'
import jsbarcode from 'jsbarcode'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
  // 获取账单
  'POST/house_lease_bill_details/bill_info': fetchList,
  // 获取所有公司
  'GET/company': companyListApi,
  // 根据租赁id获取账单
  'GET/house_lease_bill_details': detailsApi,
  // 根据账单id获取此笔账单支付凭证
  'GET/lease_payment_logs/{id}': billFilesListApi,
  // 下载支付凭证(附件)
  'GET/house_lease_contracts/download': downFileApi,
  // 删除支付附件
  'DELETE/lease_payment_logs/{id}': delFilesApi,
  // 上传支付凭证文件
  'POST/lease_payment_logs/upload': upFileApi,
  // 审批
  'GET/house_lease_bills/approve': approveApi,
  // 撤销账单
  'DELETE/house_lease_bills/{id}': deleteBillApi,
} = Api

const route = useRoute()
let billRows: any = ref([])
const handleSelectionChange = (val: object[]) => {
  billRows.value = val
}

const billTable = ref(null)
const { 
  MI_tableData, fetchData, page, size, MI_total, 
  MI_pageChange, MI_sizeChange, MI_identify, 
  MI_params, MI_modifyForm, MI_height,
} = new tbMix(fetchList)

const searchConfig = ref([
  {
    type: 'NUMBER',
    label: '租赁编号',
    value: undefined,
    upKey: 'id',
    props: { clearable: true, precision: 0 },
    // props: { type: 'number'}
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'company',
    options: [],
    placeholder: '请选择公司',
    selectFunc: companyListApi,
    seleProps: { label: 'name', valueName: 'name', },
    props: { placeholder: '请选择公司', clearable: true }
  },
  {
    type: 'SELECT',
    label: '审批状态',
    value: '',
    upKey: 'payApproveStatus',
    options: [
      { label: 'Hr审核', id: 'APPROVE_WAIT' },
      { label: '财务审核', id: 'APPROVE_SEC' },
      { label: '部分已审核', id: 'APPROVE_PART' },
      { label: '审核失败', id: 'APPROVE_FAILED' },
      { label: '审核成功', id: 'APPROVE_SUCCESS' },
    ],
    props: { clearable: true, placeholder: '请选择审批状态'},
    seleProps: {}
  },
  {
    type: "TIME",
    label: "开始时间",
    value: '',
    upKey: 'startDate',
    props: { clearable: true, }
  },
  {
    type: "TIME",
    label: "结束时间",
    value: '',
    upKey: 'endDate',
    props: { clearable: true, }
  },
  {
    type: 'SELECT',
    label: '支付状态',
    value: '',
    upKey: 'payStatus',
    options: [
      { label: '未支付', id: 'PAY_NO' },
      { label: '等待支付', id: 'PAY_WAIT' },
      { label: '支付成功', id: 'PAY_SUCCESS' },
      { label: '部分支付成功', id: 'PAY_PART_SUCCESS' },
      { label: '支付失败', id: 'PAY_FAILED' },
      { label: '等待银行审核', id: 'PAY_VERIFY' },
    ],
    props: { clearable: true, placeholder: '请选择支付状态'},
    seleProps: {}
  },
  {
    label: '所在地',
    value: '',
    upKey: 'city',
  },
  {
    type: "TIME",
    label: "创建时间",
    value: '',
    upKey: 'createdAtRange',
    upProps: { startKey: 'from', endKey: 'to', },
    props: {
      type: 'daterange',
      clearable: true,
    }
  },
  {
    label: '简称',
    value: '',
    upKey: 'alias',
  },
])
const searchFg = ref<boolean>(true)
const serachHandle = (params: any) => {
  if(route.query.id){
    params.id = parseInt(route.query.id as string)
    searchFg.value = false
  }
  fetchData({
    ...params,
    createdAt: {
      from: params.from,
      to: params.to
    }
  })
}

onActivated(() => {
  
})

// 详情
const dtFg = ref(false)
const { 
  MI_tableData: dtData, fetchData: dtFetch, page: dtPage, size: dtSize, MI_total: dtTotal, 
  MI_pageChange: dtPgChange, MI_sizeChange: dtSzChange, MI_identify: dtIdentify, 
  MI_params: dtParams
} = new tbMix(detailsApi)
const detailsHandle = async () => {
  if(billRows.value.length !== 1){
    ElMessage.warning({message: '请选择一条数据', grouping: true})
    return
  }
  await dtFetch({ billId: billRows.value[0].id })
  dtFg.value = true
}

// 附件
const filesFg = ref(false)
let filesDate = ref([])
const filesHandle = async () => {
  if(billRows.value.length !== 1){
    ElMessage.warning({message: '请选择一条数据', grouping: true})
    return
  }
  MI_identify.value = true
  try {
    filesDate.value = await billFilesListApi({id: billRows.value[0].id})
    filesFg.value = true
    MI_identify.value = false
  } catch (error) {
    MI_identify.value = false
  }
}

const downloadHandle = (row: any) => {
  downFileApi({ fileId: row.fileId}).then(url => {
    const elt = document.createElement('a')
    elt.setAttribute('href', url)
    elt.setAttribute('download', row.filename)
    elt.style.display = 'none'
    document.body.appendChild(elt)
    elt.click()
    document.body.removeChild(elt)
  })
}
const delFilesHandle = (row: {id: string}) => {
  ElMessageBox.confirm(
    '确定删除？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      return delFilesApi({id: row.id})
    })
    .then( () => {
      ElMessage.success('删除成功')
      return billFilesListApi({id: billRows.value[0].id})
    })
    .then((rep) => {
      filesDate.value = rep
    })
    .catch(() => { })
}

const upConfig = ref([
  {
    type: 'NUMBER',
    label: '金额',
    value: undefined,
    upKey: 'amount',
    props: { placeholder: '金额' },
    rule: [
      { required: true, message: '请输入金额', trigger: 'change' },
    ],
  }
])
let upParamsT = computed(() => {
  return {leaseId: billRows.value[0].leaseId, billId: billRows.value[0].id }
})
const upFilesCb = async () => {
  filesDate.value = await billFilesListApi({id: billRows.value[0].id})
}

// 审批
const approvalHandle = () =>{
  if(billRows.value.length !== 1){
    ElMessage.warning('请只选择一条租赁数据')
    return
  }
  MI_identify.value = true
  if(billRows.value[0].approved === 'APPROVE_SUCCESS'){
    approveApi({id: billRows.value[0].id}).then(() => {
      ElMessage.warning('取消审批成功')
      MI_identify.value = false
      return fetchData(MI_params)
    }).finally(() => {
      MI_identify.value = false
    })
  } else {
    approveApi({id: billRows.value[0].id}).then(() => {
      ElMessage.success('审批成功')
      MI_identify.value = false
      return fetchData(MI_params)
    }).finally(() => {
      MI_identify.value = false
    })
  }
}

// 撤销（删除）账单
const delBillHandle = async () => {
  if(billRows.value.length !== 1){
    ElMessage.warning('请只选择一条租赁数据')
    return
  }
  await deleteBillApi({id: billRows.value[0].id})
  ElMessage.success('撤销成功')
  fetchData(MI_params)
}


// console.log(html2pdf);

const pdfFg = ref<boolean>(false)
const previewPdfHandle = () => {
  if(billRows.value.length > 1 ){
    ElMessage.warning('请选择一条数据')
    return
  }

  pdfFg.value = true
  setTimeout(() => {
    jsbarcode("#barcode", 'ZL' + billRows.value[0].id, {
      // width:4,
      height:40,
    });
  })
}

const pdfSaveOption = {
  margin: 1,
  filename: '租赁账单.pdf',
  image: { type: 'jpeg', quality: 0.98 },
  html2canvas: { scale: 2 },
  jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
};
const expertPdf = () => {
  html2pdf().set(pdfSaveOption).from(document.getElementById('padPreview')).save()
}

// ----------------格式化列内容-------------------
const statusMap = {
  'PAY_NO': '未支付',
  'PAY_WAIT': '等待支付',
  'PAY_SUCCESS': '支付成功',
  'PAY_PART_SUCCESS': '部分支付成功',
  'PAY_FAILED': '支付失败',
  'PAY_VERIFY': '等待银行审核',
}
const formatpayStatus =  (row: any, column: any, cellValue: any, index: any) => {
  return (statusMap as any)[cellValue]
}
const formatpayPayTime =  (row: any, column: any, cellValue: any, index: any) => {
  if(!cellValue){
    return ''
  }
  return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
}


const approvedStatusMap = {
  'APPROVE_WAIT': 'Hr审核',
  'APPROVE_SEC': '财务审核',
  'APPROVE_PART': '部分已审核',
  'APPROVE_FAILED': '审核失败',
  'APPROVE_SUCCESS': '审核成功',
}
const formatApprovedStatus = (row: any, column: any, cellValue: any, index: any) => {
  return (approvedStatusMap as any)[cellValue]
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "租赁账单" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              title: true,
              initSearch: true,
              searchConfig: searchConfig.value
            }, { onSearchFn: serachHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, searchFg.value]
    ]),
    _hoisted_1,
    _createVNode(_component_el_button, {
      icon: "ArrowLeft",
      class: "",
      type: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ path: '/lease-table'})))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (detailsHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (filesHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (previewPdfHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    })), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "billTable",
      ref: billTable,
      border: "",
      class: "mt-10",
      data: _unref(MI_tableData),
      onSelectionChange: handleSelectionChange,
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "序号",
          prop: "id",
          fixed: ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, "ZL" + _toDisplayString(row.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "company",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "付款申请责任人",
          width: "135",
          prop: "applicant",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "审批状态",
          width: "100",
          prop: "approvedStatus",
          formatter: formatApprovedStatus
        }),
        _createVNode(_component_el_table_column, {
          label: "开始时间",
          prop: "startDate",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          label: "结束时间",
          prop: "endDate",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          label: "账单创建时间",
          prop: "createdAt",
          formatter: formatpayPayTime,
          width: "175"
        }),
        _createVNode(_component_el_table_column, {
          label: "支付时间",
          prop: "payDate",
          formatter: formatpayPayTime,
          width: "175"
        }),
        _createVNode(_component_el_table_column, {
          label: "支付状态",
          prop: "payStatus",
          formatter: formatpayStatus,
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "所在地",
          prop: "city",
          width: "125",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "简称",
          prop: "alias",
          width: "150",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "租房类型",
          prop: "purpose",
          width: "85",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "押金",
          prop: "depositFee",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "房租",
          prop: "rentFee",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "月物管费",
          prop: "pmFee",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "水电费",
          prop: "utilities",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "其他费用",
          prop: "otherFee",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency"
        }),
        _createVNode(_component_el_table_column, {
          label: "收款人",
          prop: "receiverName"
        }),
        _createVNode(_component_el_table_column, {
          label: "银行名称",
          prop: "bankName",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "收款账户",
          prop: "account",
          width: "190",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "remark",
          width: "150",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      class: "mt-10",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      top: "55px",
      title: "明细",
      modelValue: dtFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dtFg).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _unref(dtData),
          border: "",
          "max-height": "650",
          loading: _unref(dtIdentify)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "开始时间",
              prop: "startDate"
            }),
            _createVNode(_component_el_table_column, {
              label: "结束时间",
              prop: "endDate"
            }),
            _createVNode(_component_el_table_column, {
              label: "押金",
              prop: "depositFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "房租",
              prop: "rentFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "月物管费",
              prop: "pmFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "水电费",
              prop: "utilities",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "其他费用",
              prop: "otherFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "附件列表",
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_unref(fetchData)({leaseId: _ctx.$route.params.id}))),
      modelValue: filesFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filesFg).value = $event))
    }, {
      default: _withCtx(() => [
        (_unref(billRows)[0]  && _unref(billRows)[0].approvedStatus !== 'APPROVE_SUCCESS')
          ? _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
              key: 0,
              upText: '上传凭证',
              upFetch: _unref(upFileApi),
              upParams: _unref(upParamsT),
              showBtn: true,
              limit: 10,
              upConfig: upConfig.value,
              onUpSuccess: upFilesCb
            }, null, 8, ["upFetch", "upParams", "upConfig"])), [
              [_directive_permission, 'Create']
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(filesDate),
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "文件名",
              prop: "filename",
              width: "330"
            }),
            _createVNode(_component_el_table_column, {
              label: "金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "日期",
              prop: "uploadAt",
              formatter: (row, column, cellValue, index) => _unref(dayjs)(cellValue).format('YYYY-MM-DD')
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (downloadHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (_unref(billRows)[0]  && _unref(billRows)[0].approvedStatus !== 'APPROVE_SUCCESS')
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "danger",
                      onClick: ($event: any) => (delFilesHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'DELETE']
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      top: "35px",
      width: "950px",
      modelValue: pdfFg.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((pdfFg).value = $event)),
      title: "导出预览"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_40, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (expertPdf())),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_el_descriptions, {
            title: "",
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "公司名称" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(billRows)[0].company), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "申请部门" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(billRows)[0].department), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "账单申请人" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(billRows)[0].applicant), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "出租人" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(billRows)[0].lessor), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "创建时间" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(dayjs)(_unref(billRows)[0].createdAt).format('YYYY-MM-DD HH:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "所在地" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(billRows)[0].city), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "备注" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(billRows)[0].remark), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_card, {
              class: "mt-30",
              style: {"width":"380px"}
            }, {
              header: _withCtx(() => [
                _hoisted_13
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].currency), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(getNumber)( _unref(billRows)[0].rentFee )), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].currency), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(getNumber)(_unref(billRows)[0].pmFee)), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].currency), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(getNumber)(_unref(billRows)[0].utilities)), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].currency), 1),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(getNumber)(_unref(billRows)[0].depositFee)), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].currency), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(getNumber)(_unref(billRows)[0].otherFee)), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].currency), 1),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(getNumber)(_unref(billRows)[0].otherFee + _unref(billRows)[0].utilities + _unref(billRows)[0].pmFee + _unref(billRows)[0].rentFee + _unref(billRows)[0].depositFee )), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              class: "mt-30",
              style: {"width":"380px"}
            }, {
              header: _withCtx(() => [
                _hoisted_32
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].receiverName), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].bankName), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("span", null, _toDisplayString(_unref(billRows)[0].account), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, "账单审批人：" + _toDisplayString(_unref(billRows)[0].approvedStatus === 'APPROVE_SUCCESS' ? 'Grace.Gao':'                     '), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})